// extracted by mini-css-extract-plugin
export default {"notFoundWarp":"NoGifFound_notFoundWarp__c3a3q","icon":"NoGifFound_icon__PF83C"};